import _ from 'lodash'

const CustomizedXAxisTick = props => {
  const { x, y, payload, namesMapping, isExternal } = props
  // 外站且有 namesMapping 時才需要轉換 tickname
  const isNeedTrasformTickNames = isExternal && !_.isEmpty(namesMapping)
  let tickNames = payload.value

  if (isNeedTrasformTickNames) {
    tickNames = _.get(namesMapping, tickNames, tickNames)
  }
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={20}
        textAnchor='middle'
        fill='#979ba7'
        fontSize='13'
      >
        {
          isNeedTrasformTickNames
            ? (
              <>
                {tickNames.map((tickName, index) => {
                  // tickNames size === 1 名稱沒有被切割，固定 Y 軸
                  // tickNames size === 2 名稱被切割成兩個， Y 軸距離不同
                  const yPosition = _.size(tickNames) === 1
                    ? 16
                    : index === 0
                      ? 12
                      : 16
                  return (
                    <tspan
                      x={0}
                      dy={yPosition}
                      key={tickName}
                    >
                      {tickName}
                    </tspan>
                  )
                })}
              </>
            )
            : (
              <tspan
                x={0}
                dy={16}
              >
                {tickNames}
              </tspan>
            )
        }
      </text>
    </g>
  )
}

export default CustomizedXAxisTick
